import React from 'react'
import { Link } from 'react-router-dom'
import brudcrumbsvg from '../../../assets/images/about/arrow-brudcrumb.svg'
import protfoliobg from '../../../assets/images/background/protfolio-page-bg.jpg'

const PageHeader = () => {
    return (
        <>
            <div
                className="page-header-section"
                style={{
                    backgroundImage: `url(${protfoliobg})`,
                  }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-8">
                            <div
                                className="page-header-heading animate fadeInLeft wow animated"
                                data-wow-duration="2000ms"
                            >
                                <h2>Portfolio</h2>
                                <p>
                                    Leverage agile frameworks to provide a robust synopsis for high
                                    level overviews. Iterative approaches to collaborative .
                                </p>
                            </div>
                        </div>
                    </div>
                    <ul className="breadcrumb">
                        <li>
                            <Link to="/">Home</Link>
                        </li>
                        <li>
                            <img src={brudcrumbsvg} alt="icon" />
                        </li>
                        <li>
                            <span>Portfolio</span>
                        </li>
                    </ul>
                </div>
            </div >

        </>
    )
}

export default PageHeader
